import template from 'lodash/template';

const cdnUrl = `${
  process.env.RAZZLE_MAGENTO_MEDIA_URL
}/catalog/product/200x200`;

const getProductImageUrl = sku => {
  const lSku = sku.toLowerCase();
  return `${cdnUrl}/${lSku.charAt(0)}/${lSku.charAt(1)}/${lSku}.png`;
};

const formatMagentoError = error => {
  if (!error.message || !error.parameters) {
    return null;
  }
  const compiled = template(error.message, {
    interpolate: /%(\S+)/g
  });
  return compiled(error.parameters);
};

export { getProductImageUrl, formatMagentoError };
